import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { TrapActivationHistory, StatusTypes } from 'api/traps/types';
import { MLButton } from 'components/Button/Button';
import { useManageSetActivationSignalStatusModalStore } from 'pages/DevicesDetail/MCT/Modal/ManageSetActivationSignalStatusModalStore';

const CellWithStatusHistory = (data: TrapActivationHistory) => {
  const { t } = useTranslation();

  const { onManageSetActivationSignalStatusModalOpen } = useManageSetActivationSignalStatusModalStore();
  const checkApprovBy = () => {
    if (data.approved_by) {
      return `Changed on: ${data.approved_at ? dayjs(data.approved_at).format('YYYY-MM-DD\xa0HH:mm') : ''} Changed by: ${data?.approved_by ? data?.approved_by.username : ''}`;
    } else {
      return 'Correct the detected signal result (if needed)';
    }
  };
  // Determine the status class and translated status title based on approv_status
  const statusClass = (() => {
    switch (data.approv_status) {
      case StatusTypes.APPROVED_MICE:
      case StatusTypes.CONSUMPTION:
      case StatusTypes.REJECTED:
        return 'danger';

      case StatusTypes.APPROVED_NOT_MICE:
      case StatusTypes.CAUGHT_EMPTY:
      case StatusTypes.ACTIVITY:
        return 'warning';

      default:
        return '';
    }
  })();

  const statusTitle = (() => {
    switch (data.approv_status) {
      case StatusTypes.APPROVED_MICE:
        return t('MCTDetail.TrapHistoryCard.modal.approveMice');
      case StatusTypes.APPROVED_NOT_MICE:
        return t('MCTDetail.TrapHistoryCard.modal.approveNotMice');
      case StatusTypes.CAUGHT_EMPTY:
        return t('MCTDetail.TrapHistoryCard.modal.captureEmpty');
      case StatusTypes.REJECTED:
        return t('MCTDetail.TrapHistoryCard.modal.reject');
      case StatusTypes.ACTIVITY:
        return t('MCTDetail.TrapHistoryCard.modal.Activity');
      case StatusTypes.CONSUMPTION:
        return t('MCTDetail.TrapHistoryCard.modal.Consumption');
      default:
        return '';
    }
  })();

  return data.approved_by || data.approv_status ? (
    <div
      title={checkApprovBy()}
      onClick={() => {
        if (data.approv_status && data.approved_by == null)
          onManageSetActivationSignalStatusModalOpen(String(data.id) || '', data.approv_status);
      }}
      style={{ cursor: data.approv_status && data.approved_by == null ? 'pointer' : 'default' }}
    >
      <div className="d-flex align-items-end justify-content-center">
        <div>
          <span className={`badge rounded-pill border border-${statusClass} text-${statusClass}`}>{statusTitle}</span>
        </div>
        {data.approved_by && (
          <div className="avatar-xxs mx-3">
            <img
              className="rounded-circle header-profile-user"
              src={data.approved_by.image}
              alt={data.approved_by.username || 'User'}
            />
          </div>
        )}
      </div>
    </div>
  ) : (
    <MLButton
      onClick={() => onManageSetActivationSignalStatusModalOpen(String(data.id) || '')}
      isGhost
      color="success"
      innerText={t('MCTDetail.TrapHistoryCard.modal.SetStatus')}
    />
  );
};

export default CellWithStatusHistory;
